import React, {useCallback, useEffect, useState} from 'react';
import {useMsal} from '@azure/msal-react';
import {AccountInfo} from '@azure/msal-browser';
import TopBar from './common/components/TopBar';
import {loginRequest} from '../authConfig';
import {getFilterData, getDataApi} from './common/api/getApiData';
import {userData, UserContext} from './common/context/userContext';
import Loader from './common/components/Loader';
import {filterData} from './common/components/DropdownFilter';
import {FilterContext, favouriteType, filterDataType, userType} from './common/context/filterContext';
import {formatCategroryData} from './common/functions/formatData';
import {toast} from 'react-toastify';
import {AuthContext} from './common/context/authContext';
import '../assests/css/landing.scss';

interface layoutProps {
    children: React.ReactElement
}

export default function Layout(props: layoutProps) {

    const [account, setAccount]=useState<AccountInfo[]>([]);
    const {instance, accounts} = useMsal();

    const [filterData, setFilterData] = useState<filterDataType>({
        coverage: [],
        facilityType: [],
        carrier: [],
        wholesaler: [],
        states: [],
        contacts: [],
        users: [],
        favourites: [],
        search: "",
        order: 0,
        submissionReq: [],
        categories: [],
        companyCategories: []
    });

    const [filterContent, setFilterContent] = useState<filterDataType>({
        coverage: [],
        facilityType: [],
        carrier: [],
        wholesaler: [],
        states: [],
        contacts: [],
        users: [],
        favourites: [],
        search: "",
        order: 0,
        submissionReq: [],
        categories: [],
        companyCategories: []
    });

    const [userDetails, setUserDetails] = useState<userData>({
        userId: 0,
        firstName: '',
        lastName: '',
        email: '',
        active: false,
        permissions: '',
        permissionName: ''
    });

    const [loading, setLoading] = useState(false);
    const [coverage, setCoverage] = useState<filterData[]>([]);
    const [facilityType, setFacilityType] = useState<filterData[]>([]);
    const [carrier, setCarrier] = useState<filterData[]>([]);
    const [wholesaler, setWholesaler] = useState<filterData[]>([]);
    const [states, setStates] = useState<filterData[]>([]);
    const [contacts, setContacts] = useState<any[]>([]);
    const [users, setUsers] = useState<userType[]>([]);
    const [submissionReq, setSubmissionReq] = useState<[]>([]);
    const [categories, setCategories] = useState<filterData[]>([]);
    const [companyCategories, setCompanyCategories] = useState<[]>([]);
    const [favorites, setFavorites] = useState<favouriteType[] | null>([]);

    const requestProfileData= useCallback((forceRefresh?: boolean,
        redirect?: string)=> {
        instance
          .acquireTokenSilent({
            account: accounts[0],
            scopes: loginRequest.scopes,
            forceRefresh: forceRefresh,
          })
          .then((response) =>   {
            setAccount([response.account]);
            if (redirect) {
                location.replace(redirect);
            }
          });
    }, [
        accounts, instance,
    ]);

    const setFilterContextData = (filter: filterDataType,
        filterKey: string) => {
        if (filterKey === 'favorites') {
            setFavorites(filter.favourites);
        }
        if (filterKey === 'ccc') {
            setCompanyCategories(filter.companyCategories);
            setCarrier(filter.carrier);
            setContacts(filter.contacts);
        }
        if (filterKey === 'cc') {
            setCarrier(filter.carrier);
            setContacts(filter.contacts);
        }
        setFilterData(filter);
    }

    const setFilterContextContent = (filter: filterDataType) => {
        setFilterContent(filter);
    }
    
    const setUserDataContext = (userData: userData) => {
        setUserDetails(userData);
    }

    const refreshUserToken = (redirect: string) => {
        requestProfileData(true, redirect);
    }

    const getUserData = useCallback(async () => {
        try {
            if (accounts[0].username) {
                const user = await getDataApi(`User/?$filter=email eq '${accounts[0].username}'`,
                    accounts);
                if (user.length) {
                    const role = await getDataApi(`UserRole?$filter=userRoleId eq ${user[0].userRoleId}`, accounts);
                    if (role.length) {
                        setUserDataContext({...user[0], userId: user[0].id,
                            active: user[0].userStatus,
                            permissions: role[0].permission,
                            permissionName: role[0].userRoleName,
                        });
                    }
                }
            }
        }catch (err) {
            setLoading(false);
            toast.error(`Error - ${err}`);
        }
    }, [
        accounts,
    ]);

    const getMasterDataApi = async(filter: string,
        setStateFunc: (data: any)=>void,
        showAll?: boolean) => {
        const data = await getFilterData(filter, accounts, showAll);
        if (filter === 'Category') {
            setStateFunc(formatCategroryData(data));
        } else {
            setStateFunc(data);
        }
    }

    useEffect(()=> {
        async function loadLoginData() {
            setLoading(true);
            requestProfileData();
            await getUserData();
            setLoading(false);
        }
        loadLoginData();
        const tokenRefresh = setInterval(()=> {
            requestProfileData(true);
        }, 3000000) // 50 minutes
        return ()=> clearInterval(tokenRefresh);
      }, [
        getUserData, requestProfileData,
    ]);

    useEffect(()=> {
        async function getData() {
            getMasterDataApi('Coverage', setCoverage, true);
            getMasterDataApi('Category', setCategories);
            getMasterDataApi('CompanyCategory', setCompanyCategories);
            getMasterDataApi('State', setStates, true);
            getMasterDataApi('User', setUsers);
            getMasterDataApi('GetCarriers', setCarrier, true);
            getMasterDataApi('GetContacts', setContacts);
            getMasterDataApi("Company?$filter=CompanyType eq 'Wholesaler' or CompanyType eq 'Wholesale'", setWholesaler, true);
            getMasterDataApi('SubmissionRequirements', setSubmissionReq, false);
            getMasterDataApi('FacilityType', setFacilityType, true);
        }
        getData();
      }, [
      ]);

    const handleSignOut=()=> {
        instance.logoutPopup();
    }

    return (
        <FilterContext.Provider value={{filterContent: filterContent,
            filterData: {
                    ...filterData,
                    coverage: [...coverage],
                    facilityType: [...facilityType],
                    carrier: [...carrier],
                    wholesaler: [...wholesaler],
                    states: [...states],
                    users: [...users],
                    contacts: [...contacts.map((contact: any)=> {
                        return {
                            ...contact,
                            name: contact.name? contact.name: ''
                        };
                    })],
                    submissionReq: [...submissionReq],
                    categories: [...categories],
                    companyCategories: [...companyCategories],
                    favourites: favorites
                },
            setFilterContent: (filter) => setFilterContextContent(filter),
            setFilterData: (filter, filterKey) =>
                setFilterContextData(filter, filterKey)}}>
            <UserContext.Provider value={{data: userDetails,
                setUserData: (userDetails) => setUserDetails(userDetails)}}>
            <AuthContext.Provider value={{accounts: account,
                setUserToken: (redirect: string)=> refreshUserToken(redirect)}}>
                <div className="landing-container">
                {!loading? userDetails.active?
                    <><div className="landing-header">
                        <TopBar accountData={account}/>
                    </div>
                    <div className="landing-content">
                        {props.children}
                    </div></>:
                    <span
                        className="landing-loader-container
                            api-error-container">
                        Invalid user or user deactive,
                        contact your adminsitrator <br/>
                        <a className="api-error-control"
                            onClick={handleSignOut}>Sign out</a>
                        </span>:
                        <span className="landing-loader-container">
                        <Loader/> </span>}
                </div>
                </AuthContext.Provider>
            </UserContext.Provider>
        </FilterContext.Provider>
    );

}